import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const HomeSkeleton = () => {
  return (
    <div className="container mx-auto flex flex-col gap-2 px-4 py-4 md:py-10">
      <div className=" hidden md:grid grid-cols-6 gap-3 mb-8">
        <Skeleton height={100} />
        <Skeleton height={100} />
        <Skeleton height={100} />
        <Skeleton height={100} />
        <Skeleton height={100} />
        <Skeleton height={100} />
      </div>
      <div className=" md:hidden grid grid-cols-4 gap-3 mb-8">
        <Skeleton height={100} />
        <Skeleton height={100} />
        <Skeleton height={100} />
        <Skeleton height={100} />
      </div>
      <div className="w-[20%]">
        <Skeleton height={35} />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5 gap-x-7">
        <div className="flex flex-col gap-2">
          <Skeleton height={160} />
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton height={160} />
        </div>{" "}
        <div className="flex flex-col gap-2">
          <Skeleton height={160} />
        </div>{" "}
        <div className="flex flex-col gap-2">
          <Skeleton height={160} />
        </div>{" "}
        <div className="flex flex-col gap-2">
          <Skeleton height={160} />
        </div>{" "}
        <div className="flex flex-col gap-2">
          <Skeleton height={160} />
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton height={160} />
        </div>{" "}
        <div className="flex flex-col gap-2">
          <Skeleton height={160} />
        </div>
      </div>
      <div className="w-[20%] mt-4">
        <Skeleton height={35} />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5 gap-x-7">
        <div className="flex flex-col gap-2">
          <Skeleton height={100} />
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton height={100} />
        </div>{" "}
        <div className="flex flex-col gap-2">
          <Skeleton height={100} />
        </div>{" "}
        <div className="flex flex-col gap-2">
          <Skeleton height={100} />
        </div>{" "}
        <div className="flex flex-col gap-2">
          <Skeleton height={100} />
        </div>{" "}
        <div className="flex flex-col gap-2">
          <Skeleton height={100} />
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton height={100} />
        </div>{" "}
        <div className="flex flex-col gap-2">
          <Skeleton height={100} />
        </div>
      </div>
    </div>
  );
};

export default HomeSkeleton;
